import type { SaveGame } from "./schema";

export interface LocalProgressExport {
  format: "lilys-adventure-local-progress";
  version: 1;
  exportedAt: string;
  gameVersion: string;
  progress: SaveGame["progress"];
  settings: SaveGame["settings"];
}

export function createLocalProgressExport(
  save: SaveGame,
  exportedAt = new Date().toISOString(),
): LocalProgressExport {
  return {
    format: "lilys-adventure-local-progress",
    version: 1,
    exportedAt,
    gameVersion: save.gameVersion,
    progress: structuredClone(save.progress),
    settings: structuredClone(save.settings),
  };
}

export function serializeLocalProgressExport(
  save: SaveGame,
  exportedAt?: string,
): string {
  return JSON.stringify(createLocalProgressExport(save, exportedAt), null, 2);
}
